import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=493f913e&scoped=true&"
import script from "./MiPerfil.vue?vue&type=script&lang=js&"
export * from "./MiPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=493f913e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f913e",
  null
  
)

export default component.exports